// extracted by mini-css-extract-plugin
module.exports =  {"description":"G2c90nkbPF_9CkSUUdcw","tabs":"PaiJ9sFypf7fJXpItMq8","header":"XYKttvCwNeXq2dFpOzGR","primaryHeader":"FdDylcBBZ2_RJyKy20jE","actionsHeader":"sh2Mexzat_XJdUg4KqBS"};